<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Movimientos de Caja">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="cajaMovimientos" 
              :fields="cajaMovimientosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(comprobanteNumero)="data">
              {{ (data.item.comprobanteNumero == 0 ? '' : data.item.comprobanteNumero) }}
            </template>
            <!-- <template v-slot:cell(comprobanteNumero)="data">
              {{ data.item.comprobanteNumero | numero }}
            </template> -->
            <template v-slot:cell(pesos)="data">
              {{ data.item.pesos | moneda }}
            </template>
            <template v-slot:cell(cheques)="data">
              {{ data.item.cheques | moneda }}
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="goList">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cajaregistro/getField',
  mutationType: 'cajaregistro/updateField',
});

export default {
  name: 'CajaMovimientos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,

      cajaMovimientosFields: [
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { 
          key: 'comprobanteTipo',
          label: 'Comprobante'
        },
        { 
          key: 'comprobanteNumero',
          label: 'Nro.Comprobante',
          class: 'text-right'
        },
        { 
          key: 'comprobanteReferencia',
          label: 'Referencia'
        },
        {
          key: 'pesos',
          class: 'text-right'
        },
        {
          key: 'cheques',
          class: 'text-right'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'cajaMovimientos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
    ]),
  },
  created() {
    this.id = this.$route.params.id;

    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('cajaregistro/getCajaMovimientos', this.id)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goList() {
      this.$router.push({ name: 'CajasRegistros' });
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
